export const defaultKanbanBoardRowGroup = 'project';
export const defaultKanbanBoardColumnGroup = 'status';

export const excludedAllTasksFields = [
  'taskId',
  'taskDescription',
  'isCsatEnabled',
  'privateTaskDescription',
];

export const allTasksFiltersLocalStorageKey = 'all_tasks.v1.filters';

export const TASK_LIST_COLUMNS_STATE_LOCALSTORAGE_KEY =
  'all_tasks.column_order';

export const MAX_SUBTASKS_ALLOWED = 500;
export const MIN_SUBTASKS_WITHOUT_ALERT = 10;
export const TASK_CONVERSATION_PANE_WIDTH = 393;
export const TASK_DRAWER_WIDTH = 1080;
